// La réponse d'itinéraire ne fournit que le tracé (pas les coordonnées de chaque
// étape) : on ne pose donc que les marqueurs départ / arrivée, déduits des
// extrémités de la polyline décodée ([lat, lng]).
export const addEndpointMarkers = (
  L: any,
  map: any,
  points: [number, number][],
  startLabel: string,
  endLabel: string,
): any[] => {
  if (points.length === 0) return [];

  const build = (
    position: [number, number],
    color: string,
    heading: string,
    text: string,
  ) => {
    const size = 16;
    const icon = L.divIcon({
      html: `
        <div style="
          width: ${size}px;
          height: ${size}px;
          border-radius: 50%;
          background: ${color};
          border: 2px solid white;
          box-shadow: 0 1px 4px rgba(0,0,0,0.4);
        "></div>
      `,
      iconSize: [size, size],
      iconAnchor: [size / 2, size / 2],
    });

    return L.marker(position, { icon })
      .bindPopup(
        `<div style="font-size:12px"><b>${heading}</b><br/>${text}</div>`,
      )
      .addTo(map);
  };

  const markers = [build(points[0]!, "#22c55e", "🟢 Départ", startLabel)];

  if (points.length > 1) {
    markers.push(
      build(points[points.length - 1]!, "#ef4444", "🔴 Arrivée", endLabel),
    );
  }

  return markers;
};
